export class Registration {
  id?: string;
  salutation: string | null = null;
  firstName: string | null = null;
  lastName: string | null = null;
  email: string | null = null;
  phoneNumber: string | null = null;
  companyName: string | null = null;
  correspondanceLanguageISOCode?: string | null = null;
  street?: string | null = null;
  zip?: string | null = null;
  location?: string | null = null;
  country?: string | null = null;
  tokenIdentifier?: string | null = null;
  registrationValid?: boolean =false;
  errorMessage?: string | null = null;
  step4?: boolean = false;
  redirectToStep2?: boolean = false;
  redirectToStep3?: boolean = false;
  redirectToStep4?: boolean = false;
  registrationSuccessful?: boolean = false;
  ValidationSuccessful? : boolean = false;
  success: boolean = false;
  errorCode?: string | null = null;
  result: any;
}
